import React, { useState, useEffect } from 'react';
import ItemShimmer from '../../../../CommonComponent/shimmerTable';
import Bidders from './bidders';
import NoSearchScreen from '../../../../CommonComponent/ListingScreens/NoSearchScreen';
import TableHeader from '../../../../CommonComponent/ListingScreens/TableHeader';

export default function BidderTable(props) {
    const {
        bidders,
        loader,
        handleSort,
        currentSortColumn,
        searchParams,
        searchValue,
        loadingBids,
        bidderInfo,
        isSearched,
        auctionData,
        setAcceptBidderModal,
        acceptBidderModal,
        handleBidders,
        loading
    } = props;

    const [showNoBiddersMessage, setShowNoBiddersMessage] = useState(false);

    const keyword =
    decodeURIComponent(searchParams.get('keyword')).length > 20
        ? decodeURIComponent(searchParams.get('keyword')).substring(0, 20) + '...'
        : decodeURIComponent(searchParams.get('keyword'));

    const [bidderLoading, setBidderLoading] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setBidderLoading(false);
        }, 1000);

        // Check if there are no bidders to show the "No bidders" message
        if (bidders.length === 0 && !isSearched && searchValue === '') {
            setShowNoBiddersMessage(true);
        } else {
            setShowNoBiddersMessage(false);
        }
    }, [searchParams, bidders, isSearched, searchValue]);

    const columns = [
        { label: "Paddle no.", sortKey: "paddle", testId: "sort-paddle-no", minWidth: "130px" },
        { label: "Name", sortKey: "name", testId: "sort-bidder-name", minWidth: "140px" },
        { label: "Email", sortKey: "email_address", testId: "sort-bidder-email", minWidth: "170px" },
        { label: "Date registered", sortKey: "created_at", testId: "sort-date", minWidth: "170px" },
        { label: "Marketing", minWidth: "120px", center: true },
        { label: "Status", minWidth: "120px", center: true },
        { label: "", minWidth: "60px" },
    ];

    return (
        (!loadingBids && !loading)?
            <div className="md:pb-[70px] pb-[100px] pt-2 z-10 overflow-auto mt-4 customScrollbar">
                <table aria-label="Outside Table" className="w-full table-auto border-[#DEDEDE] border rounded-lg"
                    style={{borderCollapse: 'separate', borderSpacing: 0}}>
                    <TableHeader currentSortColumn={currentSortColumn} handleSort={handleSort} columns={columns} />
                    <tbody>
                        {bidders.length > 0 ? (
                            <Bidders
                                bidders={bidders}
                                auctionData={auctionData}
                                loader={loader}
                                acceptBidderModal={acceptBidderModal}
                                setAcceptBidderModal={setAcceptBidderModal}
                                handleBidders={handleBidders}
                            />
                        ) : (
                            <>
                                {showNoBiddersMessage && bidderInfo.total_bidders==0 ? renderNoBiddersMessage() : null}
                                {searchValue !== '' && !isSearched ? <NoSearchScreen searchValue={keyword} cols={7} /> : null}
                            </>
                        )}
                    </tbody>
                </table>
                {(bidderLoading || loading) && <ItemShimmer bidders={bidders} />}
            </div>
            :<ItemShimmer bidders={bidders}/>
    );
    function renderNoBiddersMessage() {
        return (
            <tr className="">
                <td colSpan="7" className="sm:text-center text-start sm:pl-0 xs:pl-[200px] pl-[100px]">
                    <div className="h-[180px] mt-[100px]">
                        <p className="text-[18px] font-medium leading-normal text-[#34343 mb-4]">
                            There are no bidders for this auction.
                        </p>
                    </div>
                </td>
            </tr>
        );
    }
}
